// extracted by mini-css-extract-plugin
module.exports = {"brand":"Sidebar--brand--24H3R","sidebar":"Sidebar--sidebar--3JpYp","sidebar_minimode":"Sidebar--sidebar_minimode--3zEL_","dev_banner":"Sidebar--dev_banner--HXNng"};